<template>
    <div>
        <v-container>
            <v-form>
                <v-row>
                    <v-col :class="parentObject.isEdit ? 'pb-3' : 'pb-0'">
                        <h2 class="pb-1">{{ this.parentObject.pageTitle }}
                            <span class="page_title_value">{{ this.parentObject.pageTitleValue }}</span>
                        </h2>
                        <p v-if="!parentObject.isEdit" class="form-subtitle">Complete the details below to create an exercise in capturing employees' objective for the period defined.</p>
                    </v-col>
                </v-row>

                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                    <v-row>
                      <v-col cols="8" class="pb-n5">
                       <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.exercisecode')"
                                type="text"
                                ref="kpiexercode"
                                :rules="[rules.required]"
                                v-model="formData.kpiexercode"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="8" class="pb-n4 mt-n8">
                       <v-text-field
                                outlined
                                :label="$t('pmreviewexercise.exercisedesc')"
                                type="text"
                                ref="kpiexerdesc"
                                :rules="[rules.required]"
                                v-model="formData.kpiexerdesc"
                                @input="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.periodstartdate')"
                                type="date"
                                ref="startdate"
                                :rules="[rules.required]"
                                v-model="formData.startdate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.periodenddate')"
                                type="date"
                                ref="enddate"
                                :rules="[rules.required]"
                                v-model="formData.enddate"
                                @input="updateValue"
                                @change="updateValue"
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.status')"
                                type="text"
                                :items="kpisettingstatus"
                                hide-selected
                                v-model="formData.kpiexerstatusid"
                                @input="updateValue"
                                @change="changeKpiExerStatus(formData.kpiexerstatusid)"
                                dense
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                            <v-autocomplete
                                outlined
                                :label="$t('pmkpiinclusion.kpiinclusionset')"
                                type="text"
                                :items="KPILibraryInclusionSetList"
                                hide-selected
                                v-model="formData.pmkpiinclusionid"
                                @input="updateValue"
                                @change="changeKPILibraryInclusionSet(formData.pmkpiinclusionid)"
                                dense
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-text-field
                                outlined
                                :label="$t('columns.code')"
                                type="text"
                                v-model="formData.pmkpiinclusioncode"
                                @input="updateValue"
                                dense
                                readonly
                                background-color="#ffeab2"
                            ></v-text-field>
                        </v-col>
                        <v-col v-if="isEdit" cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-btn color="primary" class="white--text mb-3" @click="generateRecords">
                                  {{$t('button.generaterecords')}}
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                            <v-checkbox
                                v-model="formData.staffFirst"
                                :label="$t('performancemanagement.staffreviewfirst')"
                                @change="updateValue"
                                dense
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <div class="kpi-btn-bar">
                        <div class="kpi-btn-inner">
                            <v-btn class="fbtn fbtn-success" @click="saveHandler">
                                <v-icon size="16" class="mr-1">mdi-check</v-icon>
                                {{ $t('button.save') }}
                            </v-btn>
                            <v-btn class="fbtn fbtn-cancel" @click="cancelHandler">
                                <v-icon size="16" class="mr-1">mdi-close</v-icon>
                                {{ $t('button.cancel') }}
                            </v-btn>
                            <v-btn v-if="isEdit" class="fbtn fbtn-primary" @click="publishHandler">
                                <v-icon size="16" class="mr-1">mdi-publish</v-icon>
                                {{ $t('button.publish') }}
                            </v-btn>
                            <v-btn v-if="isEdit" class="fbtn fbtn-danger" @click="revokeHandler">
                                <v-icon size="16" class="mr-1">mdi-undo</v-icon>
                                {{ $t('button.revoke') }}
                            </v-btn>
                        </div>
                    </div>

                    <v-row v-if="!this.parentObject.isWizard && !this.parentObject.loadingCommonKpi" class="mt-2">
                        <v-col cols="12">
                            <app-table
                                v-bind:parentObject="{
                                    tabHeader: this.tabHeader,
                                    detailItem: this.parentObject.commonKpiList,
                                }"
                                v-on:reload="reloadKpiCommonListHandler"
                            />
                        </v-col>
                    </v-row>

                </v-container><!-- end custom-form -->

            </v-form>
        </v-container>

        <div v-if="isSuccess">
            <app-success
                v-bind:parentObject="{
                isSuccess: this.isSuccess,
                messageSuccess: this.messageSuccess,
                }"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="handleConfirm(true)"
                v-on:cancelConfirm="handleConfirm(false)"
            />
        </div>
    </div>
</template>

<script>
import CRUDTable from './CRUDTable';
import SuccessDialog from "../../../components/common/SuccessDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-table': CRUDTable,
        'app-success':SuccessDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            formData: {
                kpiexerid: this.parentObject.id,
                kpiexercode: this.parentObject.data.kpiexercode,
                kpiexerdesc: this.parentObject.data.kpiexerdesc,
                startdate: this.parentObject.data.startdate,
                enddate: this.parentObject.data.enddate,
                kpiexerstatusid: this.parentObject.data.kpiexerstatusid,
                kpiexerstatus: this.parentObject.data.kpiexerstatus,
                staffFirst: this.parentObject.data.staffFirst,
                pmkpiinclusionid: this.parentObject.data.pmkpiinclusionid,
                pmkpiinclusioncode: this.parentObject.data.pmkpiinclusioncode,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userid,
            },

            formDataParameter: {
                servicerecasatdate: null,
                hiredate: null,
                cessationdate: null,
                isOverwrite: false,
            },

            parameters: {
                companyid: null,
                compnyname: null,
                branchid: null,
                brchname: null,
                departmentid: null,
                deptname: null,
                divisionid: null,
                divnname: null,
                sectionid: null,
                sectioname: null,
                unitid: null,
                unitname: null,
                gradeid: null,
                grddesc: null,
                employmenttypeid: null,
                emptypecatdesc: null,
                staffid: null,
                staffcode: null,
                jobid: null,
                jobtitle: null,
            },
      
            errMsg: '',
            isErr: false,
            isEdit : this.parentObject.isEdit,
            search: this.parentObject.searchnew,

            tabHeader: [
                { text: this.$t('columns.actions'), value: 'action', width: '200px', sortable: false},
                { text: this.$t('columns.description'), value: 'description', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.goal'), value: 'goal', width: '200px', sortable: true},
                { text: this.$t('pmreviewexercisesectioncard.KPI'), value: 'kpi', width: '200px', sortable: true},
                { text: this.$t('performancemanagement.targetoption'), value: 'targetoption', width: '200px', sortable: true},
                { text: this.$t('pmassementrecord.pmassessmentcalculationmethod'), value: 'calmethod', width: '200px', sortable: true},
                // { text: this.$t('pmreviewexercisesectioncard.weightage'), value: 'weightage', width: '200px', sortable: true},
                // { text: this.$t('pmreviewexercisesectioncard.threshold'), value: 'threshold', width: '200px', sortable: true},
                { text: this.$t('columns.target'), value: 'target', width: '200px', sortable: true},
                // { text: this.$t('pmreviewexercisesectioncard.stretch'), value: 'stretch', width: '200px', sortable: true},
                // { text: this.$t('columns.company'), value: 'companycode', width: '200px', sortable: true},
                // { text: this.$t('columns.branch'), value: 'brchcode', width: '200px', sortable: true},
                // { text: this.$t('columns.division'), value: 'divncode', width: '200px', sortable: true},
                // { text: this.$t('columns.department'), value: 'deptcode', width: '200px', sortable: true},
            ],

            kpisettingstatus: [],
            kpisettingFull: [],

            KPILibraryInclusionSetList: [],
            KPILibraryInclusionSetFull: [],

            workflowList: [],
            workflowFull: [],

            isSuccess: false,
            messageSuccess: "",

            confirmProceed: true,//default true
            isConfirm: false,
            messageConfirm: "",
        }
    },

    methods: {
        updateValue() {
            this.$emit('input', {
                kpiexercode: this.formData.kpiexercode,
                kpiexerdesc: this.formData.kpiexerdesc,
                startdate: this.formData.startdate,
                enddate: this.formData.enddate,
                kpiexerstatusid: this.formData.kpiexerstatusid,
                kpiexerstatus: this.formData.kpiexerstatus,
                staffFirst: this.formData.staffFirst,
                pmkpiinclusionid: this.formData.pmkpiinclusionid,
                pmkpiinclusioncode: this.formData.pmkpiinclusioncode,
                stamp: this.formData.stamp,
                userid: this.formData.userid
            });
        },

        nextHandler() {
            this.$emit('next');
        },

        saveHandler() {
            this.$emit('save');
        },

        cancelHandler() {
            this.$router.push({name: 'kpisettinglist'});
        },

        changeKpiExerStatus(id) {
            let item = this.kpisettingFull.find((item) => item.id === id);
            this.formData.kpiexerstatus = item.kpiexerstatus;
            this.updateValue();
        },

        //load status list view
        loadKpiSettingStatusListHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpiexercisestatus/all' })
            .then((res) => {

                vm.kpisettingFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.kpisettingstatus.push({
                        text: res.data.rec[i].kpiexerstatus,
                        value: res.data.rec[i].id,
                    });
                }

                if (vm.formData.kpiexerstatusid) {
                    vm.changeKpiExerStatus(vm.formData.kpiexerstatusid);
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        changeKPILibraryInclusionSet(id) {
            if(id == null || id == undefined){
                this.formData.pmkpiinclusioncode = "";
                this.updateValue();
                return;
            }
            let item = this.KPILibraryInclusionSetFull.find((item) => item.id === id);
            this.formData.pmkpiinclusioncode = item.code;
            this.updateValue();
        },

        //load KPI Library Inclusion Set
        loadKPILIbraryInclusionSetHandler() {
            const vm = this;

            this.$store.dispatch('get', { url: '/kpiinclusion/all' })
            .then((res) => {

                vm.KPILibraryInclusionSetFull = res.data.rec;

                for (let i = 0; i < res.data.rec.length; i++) {
                    
                    vm.KPILibraryInclusionSetList.push({
                        text: res.data.rec[i].description,
                        value: res.data.rec[i].id,
                    });
                }

                if (vm.formData.pmkpiinclusionid) {
                    vm.changeKPILibraryInclusionSet(vm.formData.pmkpiinclusionid);
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        // Reload common kpi list
        reloadKpiCommonListHandler() {
            this.$emit("reload");
        },

        waitForUserConfirmation() {
            return new Promise((resolve) => {
                this.isConfirm = true; // Show confirmation dialog

                // Attach event listeners dynamically
                this.handleConfirm = (confirmed) => {
                    this.isConfirm = false; // Close dialog
                    resolve(confirmed); // Resolve promise with user decision
                };
            });
        },

        async publishHandler() {

            this.messageConfirm = this.$t('performancemanagement.publishconfirmmsg');
            this.confirmProceed =  await this.waitForUserConfirmation(); // ⏳ Wait for confirmation

            if (!this.confirmProceed) {
                return; // Stop execution if user cancels
            }

            // Validate commonKpiList exists and has entries
            if (!this.parentObject.commonKpiList || this.parentObject.commonKpiList.length === 0) {
                this.isErr = true;
                this.errMsg = "There is no Common KPI to publish, please rectify";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }

            // Validate kpi exer id
            if (!this.parentObject.id) {
                this.isErr = true;
                this.errMsg = "Missing KPI Exercise ID. Cannot proceed.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }

            // Validate userId
            const userId = this.$store.getters.userId;
            if (!userId) {
                this.isErr = true;
                this.errMsg = "User ID not found. Please log in again.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }

            const vm = this;

            // Build payload as a batch (array)
            const payloadList = [];

            for (let i = 0; i < this.parentObject.commonKpiList.length; i++) {
                const item = this.parentObject.commonKpiList[i];

                // Validate required fields in each item
                if (!item.id) {
                    this.isErr = true;
                    this.errMsg = `Item at position ${i + 1} is missing required fields (id).`;
                    this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                    return;
                }

                payloadList.push({
                    kpiexercmmkpiid: item.id,
                    updatedby: userId,
                    kpiexerciseid: this.parentObject.id
                });
            }

            // Send payload as batch
            this.$store.dispatch('post', {
                url: "/kpicommonbatch",
                payload: payloadList // Now sending multiple items
            })
            .then((res) => {
                if (res.data && res.data.error) {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                } else {
                    if(res.data.status == 200){
                        this.isSuccess = false;//reset the dialog
                        this.$nextTick(() => {
                            this.isSuccess = true;
                            this.messageSuccess = this.$t('performancemanagement.publishsuccessmsg');
                        });
                    }
                    else{
                        vm.isErr = true;
                        vm.errMsg = this.$t('performancemanagement.sucessbutwrongmsg');
                        vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                    }
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || "Unknown error occurred.";
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        async revokeHandler() {
            const kpiexerciseid =  this.parentObject.id;
            if (!kpiexerciseid) {
                this.isErr = true;
                this.errMsg = "Missing KPI Exercise ID. Cannot proceed.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }

            const updatedby = this.$store.getters.userId;
            if (!updatedby) {
                this.isErr = true;
                this.errMsg = "User ID not found. Please log in again.";
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
                return;
            }
            
            this.messageConfirm = this.$t('performancemanagement.revokeconfirmmsg');
            this.confirmProceed =  await this.waitForUserConfirmation(); // ⏳ Wait for confirmation

            if (!this.confirmProceed) {
                return; // Stop execution if user cancels
            }

            const vm = this;

            this.$store.dispatch('delete', {
                url: "/kpicommonbatch/"+kpiexerciseid+"/"+updatedby,
            })
            .then((res) => {
                if (res.data && res.data.error) {
                    vm.isErr = true;
                    vm.errMsg = res.data.error;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                } else {
                    if(res.data.status == 200){
                        this.isSuccess = false;//reset the dialog
                        this.$nextTick(() => {
                            this.isSuccess = true;
                            this.messageSuccess = this.$t('performancemanagement.revokesuccessmsg');
                        });                     
                    }
                    else if(res.data.status == 300){
                        this.isSuccess = false;//reset the dialog
                        this.$nextTick(() => {
                            this.isSuccess = true;
                            this.messageSuccess = this.$t('performancemanagement.revokenothingmsg');
                        }); 
                    }
                    else{
                        console.log("something went wrong");
                        vm.isErr = true;
                        vm.errMsg = this.$t('performancemanagement.sucessbutwrongmsg');
                        vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                    }
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || "Unknown error occurred.";
                vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
            });
        },

        generateRecords() {
            this.$router.push({name: 'kpisettinggenerate', params: { formData: this.formData, formDataParameter: this.formDataParameter, parameters: this.parameters, isEdit: this.isEdit } });
        }

    },

    created() {
        this.loadKpiSettingStatusListHandler();
        this.loadKPILIbraryInclusionSetHandler();
    },
}
</script>

<style scoped>
.form-subtitle {
    font-size: 0.78rem;
    color: #9e9e9e;
    margin-top: 2px;
    margin-bottom: 12px;
    font-weight: 400;
}

.kpi-btn-bar {
    background: #F8FAFF;
    border-top: 1px solid #E8EDF5;
    border-radius: 0 0 16px 16px;
    padding: 16px 20px;
    margin-top: 8px;
    width: 100%;
}

.kpi-btn-inner {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.fbtn {
    min-width: 100px !important;
    height: 38px !important;
    border-radius: 8px !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.02em !important;
    box-shadow: none !important;
    transition: all 0.15s !important;
}
.fbtn-success { background: #059669 !important; color: #fff !important; }
.fbtn-success:hover { background: #047857 !important; }
.fbtn-cancel { background: #F1F5F9 !important; color: #64748B !important; }
.fbtn-cancel:hover { background: #E2E8F0 !important; color: #334155 !important; }
.fbtn-primary { background: linear-gradient(135deg, #4F6BFF, #7C3AFF) !important; color: #fff !important; }
.fbtn-primary:hover { opacity: 0.9 !important; }
.fbtn-danger { background: #FEE2E2 !important; color: #DC2626 !important; }
.fbtn-danger:hover { background: #DC2626 !important; color: #fff !important; }

#form-btn {
    margin-top: 80px;
    margin-bottom: 20px;
}
</style>